export default {"src":"/_next/static/media/icon_arrow_right.b5307d4d.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};